export default __webpack_public_path__ + "static/media/subscription-success-icon.ec34eec7.svg";